import { render, staticRenderFns } from "./PowerWork.vue?vue&type=template&id=32ee851d&scoped=true"
import script from "./PowerWork.vue?vue&type=script&lang=js"
export * from "./PowerWork.vue?vue&type=script&lang=js"
import style0 from "./PowerWork.vue?vue&type=style&index=0&id=32ee851d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ee851d",
  null
  
)

export default component.exports